module.exports = __webpack_public_path__ + "img/DE00747.f7bbcd9f.png";